<template>
  <nav v-if="maxPageIndex > 1" class="paginator-wrap">
    <div class="paginator">
      <a @click="$emit('updateCurrentPageIndex', 1)">&laquo;</a>
      <a
        v-for="pageIndex in page"
        :key="pageIndex"
        :class="{'active': pageIndex == currentPageIndex }"
        @click="$emit('updateCurrentPageIndex', pageIndex)"
      >
        {{ pageIndex }}
      </a>
      <a @click="$emit('updateCurrentPageIndex', maxPageIndex)">&raquo;</a>
    </div>
  </nav>
</template>

<script>
const DISPLAY_PAGENATION_MAX_COUNT = 5
const DISPLAY_PAGENATION_FRONT_OR_BACK_CHOICE = 2

export default {
  props: [
    'maxPageIndex',
    'currentPageIndex',
  ],
  computed: {
    page () {
      let displayPages = []
      if (this.currentPageIndex <= DISPLAY_PAGENATION_FRONT_OR_BACK_CHOICE) {
        // 選択肢の小さい値2つ
        for (let i = 1; i <= DISPLAY_PAGENATION_MAX_COUNT; i++) {
          if (i > this.maxPageIndex) break
          displayPages.push(i)
        }
      } else if (this.currentPageIndex > (this.maxPageIndex - DISPLAY_PAGENATION_FRONT_OR_BACK_CHOICE)) {
        // 選択肢の大きい値2つ
        for (let i = this.maxPageIndex; i > (this.maxPageIndex - DISPLAY_PAGENATION_MAX_COUNT); i--) {
          if (i <= 0) break
          displayPages.push(i)
        }
        displayPages.reverse()
      } else {
        for (let i = (this.currentPageIndex - DISPLAY_PAGENATION_FRONT_OR_BACK_CHOICE); i <= (this.currentPageIndex + DISPLAY_PAGENATION_FRONT_OR_BACK_CHOICE); i++) {
          displayPages.push(i)
        }
      }
      return displayPages
    },
  },
}
</script>

<style lang="scss" scoped>
.paginator-wrap {
  text-align: center;
  .paginator {
    display: inline-block;
    text-align: center;
    a {
      cursor: pointer;
      float: left;
      padding: 4px 12px;
      text-decoration: none;
      transition: background-color .3s;
      border: 1px solid #ddd;
      &:hover {
        background-color: #eee;
      }
      &.active {
        background-color: #484848;
        color: #fff;
        border: 1px solid #484848;
        &:hover {
          background-color: #666;
        }
      }
    }
  }
}
</style>
